import { useSyncExternalStore } from "react";

/**
 * 미디어 쿼리를 자바스크립트에서 읽는다.
 *
 * 배치는 되도록 CSS로 가른다 — 클래스는 창을 줄이는 즉시 따라오고, 자바스크립트가
 * 개입하지 않아 어긋날 일이 없다. 여기가 필요한 경우는 **CSS로 못 넘기는 값**을
 * 넘길 때뿐이다. 예를 들어 팝오버가 어느 쪽으로 열릴지는 클래스가 아니라 Radix에
 * 넘기는 `side` 값이라, 미디어 쿼리로는 바꿀 수 없다.
 *
 * `useSyncExternalStore`를 쓰면 첫 렌더에서도 바로 맞는 값이 나온다. state와
 * effect로 하면 한 프레임 동안 틀린 값으로 그렸다가 고쳐지고, 그 사이 팝오버가
 * 엉뚱한 쪽으로 열렸다 되돌아온다.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    // 서버에서는 창이 없다. 좁은 쪽을 기본으로 둔다 — 넓은 화면에서 잠깐 좁게
    // 보이는 편이, 좁은 화면에서 화면 밖으로 나가는 것보다 덜 나쁘다.
    () => true,
  );
}

/** Tailwind `md` 아래. 서랍·한 칸 배치가 도는 구간이다. */
export const NARROW_QUERY = "(max-width: 47.99rem)";
